export default __webpack_public_path__ + "static/media/IframeIcon.a9bb4697.svg";